module.exports = __webpack_public_path__ + "img/spamtitan-square.012b563e.png";